//File Generated by Castle.
//!IMPORTANT Manual Changes to this file will be overwritten
export const contentMap = {
  LookingToDoPage: {
    title: 'Let\'s build your quote. What are you looking to do?',
    secondChoice: 'Buy a Home',
    thirdChoice: 'Build a Home',
    fourthChoice: 'Refinance',

  },
  PreapprovedGetStartedPage: {
    title: 'Okay! We can help with that. How would you like to get started?',
    firstChoice: 'Learn - Get helpful tips',
    secondChoice: 'Apply now - Jump to pre-approved application',

  },
  PreapprovedFirstTimePage: {
    title: 'Great! Tell us a little about you.',
    subtitle: 'Is this your first time buying a home?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  PreapprovalApplyNowPage: {
    title: 'Ready to roll?',
    subtitle: 'Let\'s start your application!',
    buttonTitle: 'Apply for Pre-Approval',

  },
  PreapprovalConfidentNowGoodTimePage: {
    title: 'How exciting! Before you get your pre-approval letter and start shopping, make sure you\'re confident that now is a good time in your life to buy a home.',
    buttonTitle: 'Next',
    tip: 'There\'s never a "right time" to buy a home that applies to everyone. It\'s a personal decision based on your own financial and emotional readiness. Don\'t think of it as an investment. It is your home and a long-term commitment.',

  },
  PreapprovalIsItRightTimePage: {
    title: 'Is it the right time to buy a home?',
    subtitle: 'Let\'s explore the both emotional and financial sides.',
    buttonTitle: 'Next',

  },
  PreapprovalEmotionallyReadyPage: {
    title: 'Are you emotionally ready?',
    subtitle: 'You\'re likely ready to commit to buying a home if:',
    firstListItem: 'You\'re looking for a long-term home vs. a short-term property investment',
    secondListItem: 'You\'re ready to commit to living in one place for 5-10 years',
    thirdListItem: 'You\'re not feeling stressed about money at this time in your life',
    fourthListItem: 'You have a strong feeling that you\'re ready to become a homeowner',
    buttonTitle: 'Next',

  },
  PreapprovalFinanciallyReadyPage: {
    title: 'Are you financially ready?',
    subtitle: 'You\'re likely ready to take on the financial responsibility of buying and owning a home if:',
    firstListItem: 'Your cash flow is good',
    secondListItem: 'You have a debt-to-income ratio (DTI) of 43% or lower',
    thirdListItem: 'You have enough money saved to make a down payment of 5% or more',
    fourthListItem: 'You\'re not expecting any significant decrease in income in the near future',
    buttonTitle: 'Next',

  },
  PreapprovalHowMuchSpendPage: {
    title: 'If you\'re emotionally ready and your debt-to-income ratio (DTI) is fairly low, you are likely ready to buy a home.',
    subtitle: 'The real question is: How much should you spend?',
    tip: 'Follow the one-third rule',
    buttonTitle: 'Next',

  },
  PreapprovalWhatToDoNextPage: {
    title: 'Use this calculator to play with the numbers and decide on a price point you\'re comfortable with.',
    subtitle: 'What would you like to do next?',
    firstChoice: 'Apply for pre-approval',
    secondChoice: 'Come back later',

  },
  PreapprovalChecklistPage: {
    title: 'Ready to roll?',
    subtitle: 'Let\'s start your application!',
    buttonTitle: 'Apply for Pre-Approval',

  },
  PreapprovalWhatToDoWithCurrentHomePage: {
    title: 'Okay! What do you plan to do with your current home?',
    firstChoice: 'I don\'t currently own a home.',
    secondChoice: 'I will sell my current home.',
    thirdChoice: 'I will keep my current home in addition to the new home.',

  },
  PreapprovalCouldBeFirstTimeHomebuyerPage: {
    title: 'Did you know? If you have not owned a primary residence for 3 years, you may qualify as a first-time homebuyer.',
    buttonTitle: 'Next',

  },
  PreapprovalHowCoordinateBuySellPage: {
    title: 'Great. Have you thought about how you\'ll coordinate your buying & selling timelines?',
    subtitle: 'Use the table to review your options',
    buttonTitle: 'Next',

  },
  PreapprovalWhatToDoWithSecondHomePage: {
    title: 'Okay. What will you do with the property that\'s not your primary residence?',
    firstChoice: 'Use it as a second home or vacation home.',
    secondChoice: 'Rent it out all or part of the year.',

  },
  PreapprovalPricePointPage: {
    title: 'What\'s your price point?',
    subtitle: 'Use the calculator to figure out what you can afford.',
    tip: 'HEADS UP! You must put down 10% or more when buying a second or vacation home.',
    buttonTitle: 'Next',

  },
  PreapprovalIsRentalWorthItPage: {
    title: 'Is it worth it?',
    subtitle: 'Before you invest in a rental property, make sure you\'ve calculated your numbers right.',
    buttonTitle: 'Next',

  },
  BuyFirstTimePage: {
    title: 'Have you owned a home in the last 3 years?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  BuySignedContractFirstTimeHomebuyerPage: {
    title: 'Do you have a signed contract?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  BuyHaveThirtyDaysPage: {
    title: 'Do you have at least 30 days before your closing date?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  BuyPreApprovalWithUswfPage: {
    title: 'Did you get your pre-approval letter from Clear Loans or US Wide Financial?',
    tip: 'The clock is ticking! You don\'t have time to shop around for lenders. You\'ll need to apply for a home loan with the same lender that gave you pre-approval.',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  BuyPreApprovedApplyNowPage: {
    title: 'Great! Please apply right away!',
    buttonTitle: 'Apply now',
    subtitle: 'We\'re happy to hear that you\'re already working with us! Please submit your home loan application ASAP so we can get things rolling. Time is of the essence!',

  },
  BuyPreApprovedWithOtherPage: {
    title: 'Sorry to hear that!',
    subtitle: 'Since you\'re closing in under 30 days, you\'ll need to apply with the same lender that gave you pre-approval.',
    buttonTitle: 'Return to Home page',
    secondarySubtitle: 'IMPORTANT: Submit your loan application to your current lender ASAP to get things rolling. Time is of the essence! Good luck on your journey to homeownership:)',

  },
  BuyDoYouHavePreapprovalPage: {
    title: 'Do you already have a pre-approval letter?',
    subtitle: 'Sounds like you\'re still searching for the perfect home or working to get it under contract. Are you pre-approved for a home loan?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  BuyDoYouWantHypotheticalQuotePage: {
    title: 'Excellent! What do you want to do next?',
    subtitle: 'Once you have a signed contract, come back to get a quote and apply! Meanwhile, do you want to run a hypothetical quote on a property you\'re interested in?',
    firstChoice: 'Build a hypothetical quote',
    secondChoice: 'Get helpful tips for first-time buyers',

  },
  BuyDoYouWantToApplyPreapprovalFirstTimePage: {
    title: 'Would you like to apply for pre-approval now?',
    subtitle: 'Apply online and get your pre-approval letter in as little as 24 hours.',
    tip: 'Tip: Pre-approval is an important step in the home loan process. Don\'t skip it!',
    firstChoice: 'Get pre-approved',
    secondChoice: 'Continue with quote',

  },
  BuySignedContractNotFirstTimeHomebuyerPage: {
    title: 'Do you have a signed contract?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  BuyDoYouWantToApplyForPreapprovalNotFirstTimePage: {
    title: 'What would you like to do next?',
    subtitle: 'Sounds like you\'re still searching for the perfect home or working to get it under contract. What can we help you with in the meantime?',
    firstChoice: 'Apply for pre-approval',
    secondChoice: 'Build a hypothetical quote',
    tip: 'If you don\'t already have a pre-approval letter, now\'s a good time. Apply online and get pre-approved in as little as 24 hours.',

  },
  BuyDoYouOwnAHomePage: {
    title: 'Do you currently own a home?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  BuyHowWillYouCoordinatePage: {
    title: 'How will you coordinate buying and selling?',
    firstChoice: 'Sell current home first, then shop for new home',
    secondChoice: 'Buy new home first, then put current home on the market',
    thirdChoice: 'Buy new home on a contingency (agree to buy only if you\'re able to sell your current home in a given period)',
    fourthChoice: 'N/A (Not applicable)',

  },
  BuyDoYouWantToFastTrackPage: {
    title: 'Okay! Let\'s build your quote.',
    subtitle: 'How would you like to proceed?',
    firstChoice: 'I\'m experienced. Let\'s fast-track this.',
    secondChoice: 'I need some guidance. Walk me through it.',

  },
  BuildDoYouHavePlansPage: {
    title: 'Are you building a home that comes with the land and home plans provided by the builder?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    tip: 'Why do we ask? This will determine what type of loan you\'ll need.',

  },
  BuildYouWillNeedConstructionLoanPage: {
    title: 'You will need a Construction loan.',
    subtitle: 'Sorry! We can\'t help with that.',
    secondarySubtitle: 'Clear does not currently have any loan options available for a custom build. Come back to us and apply for a Construction-to-Permanent loan once the home is fully constructed! Meantime, use our Quote Builder to play with the numbers based on today\'s rates.',
    buttonTitle: 'Play with the numbers',

  },
  BuildYouNeedConstructionToPermanentLoanPage: {
    title: 'OK! You will need a Construction-to-Permanent loan.',
    buttonTitle: 'Next',

  },
  BuildWhenDoYouPlanToClosePage: {
    title: 'When do you plan to close?',
    firstChoice: 'Within 30-90 days',
    secondChoice: 'In 90 days or more',
    tip: 'FYI: You will need a Construction-to-Permanent loan. We can help with that!',

  },
  BuildLetsBuildYourQuotePage: {
    title: 'Great! Let\'s build your quote.',
    buttonTitle: 'Let\'s go!',
    subtitle: 'Your closing date is coming up soon! Now\'s a good time to go ahead and lock your rate.',

  },
  BuildWithinNinetyDaysPage: {
    title: 'OK! Once you\'re within 90 days of closing, that will be a good time to lock your rate.',
    buttonTitle: 'Next',

  },
  BuildDosAndDontsPage: {
    title: 'In the meantime...',
    subtitle: 'Here are some Do\'s & Don\'ts to follow as you go through the process of building a home:',
    buttonTitle: 'Next',

  },
  BuildLoanCommitmentPage: {
    title: 'Pre-Approval vs Loan Commitment',
    subtitle: 'HEADS UP! If your builder requires a Loan Commitment (meaning they want you to apply and lock your rate) before you\'re within 90 days of closing, beware the potential risks.',
    buttonTitle: 'Next',

  },
  BuildWhatNextPage: {
    title: 'What would you like to do next?',
    firstChoice: 'Build a Quote (play with the numbers based on today\'s rates)',
    secondChoice: 'Get Pre-Approved',
    thirdChoice: 'Apply (not recommended at this time)',
    fourthChoice: 'Come back later',
    subtitle: 'Once you\'re within 90 days of closing, that will be a good time to lock your rate. Meanwhile, you can:',
    tip: 'CAUTION! If your builder requires a Loan Commitment (meaning they want you to apply and lock your rate) before you\'re within 90 days of closing, beware the potential risks.',

  },
  RefinancePrimaryReasonPage: {
    title: 'Great! We can help you better if you answer a few quick questions before building your quote. (Don\'t worry we won\'t ask for your SSN!)',
    subtitle: 'What\'s your primary reason for refinancing?',
    firstChoice: 'Current rates are low',
    secondChoice: 'I want a lower monthly payment',
    thirdChoice: 'I want to pay off my loan sooner',
    fourthChoice: 'I want to switch to a fixed rate mortgage',
    fifthChoice: 'I\'m getting divorced',
    sixthChoice: 'I\'m preparing for retirement',
    seventhChoice: 'I want to take out equity (cash-out refinance)',
    eighthChoice: 'I\'d rather not say',

  },
  RefinanceCashOutCalculatorPage: {
    title: 'Okay! Run the numbers to see how much you could borrow with a cash-out refinance.',
    tip: 'Tip: Deciding between a cash-out refinance and a home equity loan? If you can get a lower rate than your original mortgage, cash-out refi is probably your best option.',
    buttonTitle: 'Next',

  },
  RefinanceShouldYouRefinancePage: {
    title: 'First, run the numbers.',
    tip: 'Tip: If you can shave time off your loan term while keeping your monthly payment the same, that\'s a good sign that refinancing makes sense, financially speaking.',
    buttonTitle: 'Next',
    subtitle: 'Optional: Use this calculator to see if refinancing makes sense before you move forward with your rate quote.',

  },
  RefinanceWhatNextPage: {
    title: 'Let\'s build your quote!',
    subtitle: 'How would you like to proceed?',
    firstChoice: 'I\'m very experienced. Let\'s fast-track this.',
    secondChoice: 'I want some guidance. Walk me through it.',

  },
  RefinanceIrqAddressPage: {
    title: 'What\'s the address of the property you want to refinance?',
    buttonTitle: 'Next',
    tip: 'Why a full address? Some loan programs are specific to an area smaller than the zip code. Without this info, you might miss out on a great loan option you otherwise wouldn’t have known about. We don’t use this info for marketing purposes.',

  },
  RefinanceIrqNotSupportedPage: {
    title: 'Sorry, this state is not currently supported.',
    subtitle: 'Ask your real estate agent for a list of reputable lenders in your area.',
    buttonTitle: 'Return to Home page',

  },
  RefinanceIrqPrimaryResidencePage: {
    title: 'Is this your primary residence?',
    firstChoice: 'Yes, it is my primary home',
    secondChoice: 'No, it is my second home or vacation home',
    thirdChoice: 'No, I plan to rent it out all or part of the year',
    tip: 'CAUTION! If you rent out the home for money, it\'s legally considered an investment property. Lying about an investment property is fraud.',

  },
  RefinanceIrqPropertyTypePage: {
    title: 'What type of property is it?',
    buttonTitle: 'Next',

  },
  RefinanceIrqPropertyValuePage: {
    title: 'What was the purchase price?',
    buttonTitle: 'Next',

  },
  RefinanceIrqExistingBalancePage: {
    title: 'What is your existing loan balance?',
    buttonTitle: 'Next',

  },
  RefinanceIrqTakeCashOutPage: {
    title: 'Would you like to take cash out?',
    firstChoice: 'Yes',
    tip: 'A cash-out refinance replaces your existing mortgage with a new one and allows you to "take cash out," or access a portion of the equity in the form of cash. The money can be used to consolidate debts or pay for home improvements, healthcare expenses, college tuition, etc.',
    secondChoice: 'No',

  },
  RefinanceIrqHowMuchCashOutPage: {
    title: 'How much cash will you take out?',
    buttonTitle: 'Next',

  },
  RefinanceIrqCreditScorePage: {
    title: 'What is your credit score?',
    tip: 'Tip: If you\'re buying a home as joint purchase with your spouse (or other co-borrower), select the credit score that is lower.',
    buttonTitle: 'Next',

  },
  RefinanceIrqVeteranPage: {
    title: 'Are you a veteran or active duty military?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    tip: 'If you\'re a veteran, you have more loan options to consider. VA loans are available to American veterans, active U.S. military members, reservists, and select surviving spouses.',

  },
  RefinanceIrqSelfEmployedPage: {
    title: 'Are you self-employed?',
    buttonTitle: 'Next',

  },
  RefinanceIrqClosingDatePage: {
    title: 'When do you plan to close?',
    buttonTitle: 'Next',

  },
  RefinanceIrqWaiveEscrowPage: {
    title: 'Would you like to waive escrow?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not sure',
    tip: 'Selecting "No" means your property taxes and homeowners insurance will be added to your monthly mortgage payment and held in an escrow account until the annual premiums are due. Selecting "Yes" means you will pay your taxes and insurance bills on your own. IMPORTANT! If you decide to waive escrow, you will be charged a one-time fee at closing.',

  },
  RefinanceIrqLoanOptionsPage: {
    title: 'What type(s) of loan options are you interested in?',
    buttonTitle: 'Next',
    tip: 'A fixed rate mortgage has the same interest rate and the same monthly payment for the entire term of the loan. An adjustable rate mortgage (ARM) has an interest rate that is fixed for 5, 7, or 10 years, and then it adjusts every 6 months.',

  },
  RefinanceIrqConfirmationPage: {
    title: 'Does everything look good?',
    buttonTitle: 'Get Quote',
    tip: '* If you waive escrow, you will be charged a one-time fee at closing.',

  },
  RefinanceIrqComparePage: {
    title: 'Select up to 5 loans to compare.',
    tooltipRateApr: 'Rate vs. APR: The interest rate does not include lender fees or points. The annual percentage rate (APR) combines the interest rate and various lender fees into a single rate. This makes it easier for borrowers to compare different loan options.',
    tooltip1: 'PMI is calculated based on the assumption that your debt-to-income ratio is 30%.',
    tooltip2: 'Closing costs are fees paid at the completion or “closing” of a real estate transaction. Mortgage closing costs range from 2–5% of the home’s purchase price.',
    tooltip3: 'Based on the rate you select, we either charge you a “Lender Fee” or give you a “Lender Credit.” To keep things simple and straightforward, we charge you one lump sum rather than tacking on a bunch of miscellaneous fees.',
    tooltip4: 'The services and service providers in this section are required and must be chosen by the lender. You cannot shop separately for them. These legally-required services will vary depending on the type of loan you’ve chosen (e.g., VA, FHA, USDA).',
    tooltip5: 'These services are required, but you don’t have to purchase them through the lender. You can shop separately for them if you like. For example, you have the right to choose your own title company. However, our title vendors are typically priced better.',
    tooltip6: 'Government fees include recording fees, transfer taxes, and VA or FHA funding fees, if applicable.',
    tooltip7: 'This is a credit that will be subtracted from your total closing costs.',
    tooltip8: 'The amount of money needed to complete the transaction. Cash to close is a combination of closing costs, prepaids, and escrows. You’ll pay this amount at closing in the form of a cashier’s check or wire transfer.',
    tooltip9: 'Primary items include the closing costs associated with the loan you\'ve selected.',
    tooltip10: 'Prepaids include mortgage interest and homeowners insurance premiums that are paid at the time of closing.',
    tooltip11: 'Escrows include property taxes and homeowners insurance. The amount due at closing depends on your closing date and what month the annual premiums are due. It\'s calculated to ensure you will have 14 months of escrow payments (1 year plus a 2 month cushion in case taxes or insurance are higher than the previous year) in your account by the time the premiums are due.',

  },
  BuildIrqAddressPage: {
    title: 'What\'s the address of the property you want to buy?',
    buttonTitle: 'Next',
    tip: 'Why a full address? Some loan programs are specific to an area smaller than the zip code. Without this info, you might miss out on a great loan option you otherwise wouldn’t have known about. We don’t use this info for marketing purposes.',

  },
  BuildIrqNotSupportedPage: {
    title: 'Sorry, this state is not currently supported.',
    subtitle: 'Ask your real estate agent for a list of reputable lenders in your area.',
    buttonTitle: 'Return to Home page',

  },
  BuildIrqPrimaryResidencePage: {
    title: 'Will this be your primary residence?',
    firstChoice: 'Yes, it will be my primary home',
    secondChoice: 'No, it will be my second home or vacation home',
    thirdChoice: 'No, I plan to rent it out all or part of the year',
    buttonTitle: 'Next',

  },
  BuildIrqPropertyTypePage: {
    title: 'What type of property is it?',
    buttonTitle: 'Next',

  },
  BuildIrqPropertyValuePage: {
    title: 'What is the purchase price?',
    buttonTitle: 'Next',
    tip: 'Enter the estimated purchase price to proceed with your quote. Note that the final purchase price may vary due to feature selections and upgrades.',

  },
  BuildIrqDownPaymentPage: {
    title: 'How much will you put down?',
    buttonTitle: 'Next',
    tip: 'For a conventional home loan on a primary residence, the minimum down payment is 3% for first-time homebuyers and 5% for repeat buyers. For a second or vacation home, the minimum is 10%. For a rental home, you must put down 20%.',

  },
  BuildIrqCreditScorePage: {
    title: 'What is your credit score?',
    tip: 'Tip: If you\'re buying a home as joint purchase with your spouse (or other co-borrower), select the credit score that is lower.',
    buttonTitle: 'Next',

  },
  BuildIrqVeteranPage: {
    title: 'Are you a veteran or active duty military?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    tip: 'If you\'re a veteran, you have more loan options to consider. VA loans are available to American veterans, active U.S. military members, reservists, and select surviving spouses.',

  },
  RefinanceIrqUsCitizenPage: {
    title: 'Are you a U.S. citizen?',
    buttonTitle: 'Next',
    tip: 'If you are not a legal citizen of the United States of America, you might not qualify for certain loan programs.',

  },
  BuildIrqUsCitizenPage: {
    title: 'Are you a U.S. citizen?',
    buttonTitle: 'Next',
    tip: 'If you are not a legal citizen of the United States of America, you might not qualify for certain loan programs.',

  },
  BuildIrqSelfEmployedPage: {
    title: 'Are you self-employed?',
    buttonTitle: 'Next',

  },
  BuildIrqRealEstateAgentPage: {
    title: 'Are you working with a real estate agent?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not Sure',

  },
  BuildIrqClosingDatePage: {
    title: 'When do you plan to close?',
    buttonTitle: 'Next',

  },
  BuildIrqWaiveEscrowPage: {
    title: 'Would you like to waive escrow?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not sure',
    tip: 'Selecting "No" means your property taxes and homeowners insurance will be added to your monthly mortgage payment and held in an escrow account until the annual premiums are due. Selecting "Yes" means you will pay your taxes and insurance bills on your own. IMPORTANT! If you decide to waive escrow, you will be charged a one-time fee at closing.',

  },
  BuildIrqLoanOptionsPage: {
    title: 'What type(s) of loan options are you interested in?',
    buttonTitle: 'Next',
    tip: 'A fixed rate mortgage has the same interest rate and the same monthly payment for the entire term of the loan. An adjustable rate mortgage (ARM) has an interest rate that is fixed for 5, 7, or 10 years, and then it adjusts every 6 months.',

  },
  BuildIrqConfirmationPage: {
    title: 'Does everything look good?',
    buttonTitle: 'Get Quote',
    tip: '* If you waive escrow, you will be charged a one-time fee at closing.',

  },
  BuildIrqComparePage: {
    title: 'Select up to 5 loans to compare.',
    tooltipRateApr: 'Rate vs. APR: The interest rate does not include lender fees or points. The annual percentage rate (APR) combines the interest rate and various lender fees into a single rate. This makes it easier for borrowers to compare different loan options.',
    tooltip1: 'PMI is calculated based on the assumption that your debt-to-income ratio is 30%.',
    tooltip2: 'Closing costs are fees paid at the completion or “closing” of a real estate transaction. These fees are incurred by either the buyer or the seller. Mortgage closing costs range from 2–5% of the home’s purchase price.',
    tooltip3: 'Based on the rate you select, we either charge you a “Lender Fee” or give you a “Lender Credit.” To keep things simple and straightforward, we charge you one lump sum rather than tacking on a bunch of miscellaneous fees.',
    tooltip4: 'The services and service providers in this section are required and must be chosen by the lender. You cannot shop separately for them. These legally-required services will vary depending on the type of loan you’ve chosen (e.g., VA, FHA, USDA).',
    tooltip5: 'These services are required, but you don’t have to purchase them through the lender. You can shop separately for them if you like. For example, you have the right to choose your own title company. However, our title vendors are typically priced better.',
    tooltip6: 'Government fees include recording fees, transfer taxes, and VA or FHA funding fees, if applicable.',
    tooltip7: 'This is a credit that will be subtracted from your total closing costs.',
    tooltip8: 'The amount of money needed to complete the transaction of buying a home. Cash to close is a combination of down payment, closing costs, and prepaids minus earnest money and credits. You’ll pay this amount at closing in the form of a cashier’s check or wire transfer.',
    tooltip9: 'Primary items include your down payment and the closing costs associated with the loan you\'ve selected.',
    tooltip10: 'Prepaids include mortgage interest and homeowners insurance premiums that are paid at the time of closing.',
    tooltip11: 'Escrows include property taxes and homeowners insurance. The amount due at closing depends on your closing date and what month the annual premiums are due. It\'s calculated to ensure you will have 14 months of escrow payments (1 year plus a 2 month cushion in case taxes or insurance are higher than the previous year) in your account by the time the premiums are due.',
    tooltip12: 'Credits are subtracted from your total cash to close. These include your earnest money payment and a seller and/or realtor credit (if applicable).',

  },
  PurchaseIrqAddressPage: {
    title: 'What\'s the address of the property you want to buy?',
    buttonTitle: 'Next',
    tip: 'Why a full address? Some loan programs are specific to an area smaller than the zip code. Without this info, you might miss out on a great loan option you otherwise wouldn’t have known about. We don’t use this info for marketing purposes.',

  },
  PurchaseIrqNotSupportedPage: {
    title: 'Sorry, this state is not currently supported.',
    subtitle: 'Ask your real estate agent for a list of reputable lenders in your area.',
    buttonTitle: 'Return to Home page',

  },
  PurchaseIrqPrimaryResidencePage: {
    title: 'Will this be your primary residence?',
    firstChoice: 'Yes, it will be my primary home',
    secondChoice: 'No, it will be my second home or vacation home',
    thirdChoice: 'No, I plan to rent it out all or part of the year',
    buttonTitle: 'Next',
    tip: 'CAUTION! If you rent out the home for money, it’s legally considered an investment property. Lying about an investment property is fraud.',

  },
  PurchaseIrqPropertyTypePage: {
    title: 'What type of property is it?',
    buttonTitle: 'Next',
    tip: 'It’s very difficult to know the difference between a townhouse and a condominium based on physical characteristics alone. For example, it may look like a townhome, but if an HOA (homeowners association) covers the insurance for the structure of the property, it’s actually a condo. Check the public county records to find out if the property is legally listed as a townhome or condominium.',

  },
  PurchaseIrqPropertyValuePage: {
    title: 'What is the purchase price?',
    buttonTitle: 'Next',

  },
  PurchaseIrqDownPaymentPage: {
    title: 'How much will you put down?',
    buttonTitle: 'Next',
    tip: 'For a conventional home loan on a primary residence, the minimum down payment is 3% for first-time homebuyers and 5% for repeat buyers. For a second or vacation home, the minimum is 10%. For a rental home, you must put down 20%.',

  },
  PurchaseIrqCreditScorePage: {
    title: 'What is your credit score?',
    tip: 'Tip: If you\'re buying a home as joint purchase with your spouse (or other co-borrower), enter the credit score that is lower.',
    buttonTitle: 'Next',

  },
  PurchaseIrqVeteranPage: {
    title: 'Are you a veteran or active duty military?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    tip: 'As a veteran, you have more loan options to consider. VA loans are available to American veterans, active U.S. military members, reservists, and select surviving spouses.',

  },
  PurchaseIrqUsCitizenPage: {
    title: 'Are you a U.S. citizen?',
    buttonTitle: 'Next',
    tip: 'If you are not a legal citizen of the United States of America, you might not qualify for certain loan programs.',

  },
  PurchaseIrqSelfEmployedPage: {
    title: 'Are you self-employed?',
    buttonTitle: 'Next',

  },
  PurchaseIrqRealEstateAgentPage: {
    title: 'Are you working with a real estate agent?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not Sure',

  },
  PurchaseIrqForSaleByOwnerPage: {
    title: 'Is the property For Sale By Owner?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not Sure',

  },
  PurchaseIrqTitleCompanyPage: {
    title: 'Do you have a Title Company you plan to use?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not Sure',

  },
  PurchaseIrqAsIsPage: {
    title: 'Are you buying "as-is"?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not Sure',

  },
  PurchaseIrqClosingDatePage: {
    title: 'When do you plan to close?',
    buttonTitle: 'Next',

  },
  PurchaseIrqWaiveEscrowPage: {
    title: 'Would you like to waive escrow?',
    buttonTitle: 'Next',
    firstChoice: 'Yes',
    secondChoice: 'No',
    thirdChoice: 'Not sure',
    tip: 'Selecting "No" means your property taxes and homeowners insurance will be added to your monthly mortgage payment and held in an escrow account until the annual premiums are due. Selecting "Yes" means you will pay your taxes and insurance bills on your own. IMPORTANT! If you decide to waive escrow, you will be charged a one-time fee at closing.',

  },
  PurchaseIrqLoanOptionsPage: {
    title: 'What type(s) of loan options are you interested in?',
    buttonTitle: 'Next',
    tip: 'A fixed rate mortgage has the same interest rate and the same monthly payment for the entire term of the loan. An adjustable rate mortgage (ARM) has an interest rate that is fixed for 5, 7, or 10 years, and then it adjusts every 6 months.',

  },
  PurchaseIrqConfirmationPage: {
    title: 'Does everything look good?',
    buttonTitle: 'Get Quote',
    tip: '* If you waive escrow, you will be charged a one-time fee at closing.',

  },
  PurchaseIrqComparePage: {
    title: 'Select up to 5 loans to compare.',
    tooltipRateApr: 'Rate vs. APR: The interest rate does not include lender fees or points. The annual percentage rate (APR) combines the interest rate and various lender fees into a single rate. This makes it easier for borrowers to compare different loan options.',
    tooltip1: 'PMI is calculated based on the assumption that your debt-to-income ratio is 30%.',
    tooltip2: 'Closing costs are fees paid at the completion or “closing” of a real estate transaction. These fees are incurred by either the buyer or the seller. Mortgage closing costs range from 2–5% of the home’s purchase price.',
    tooltip3: 'Based on the rate you select, we either charge you a “Lender Fee” or give you a “Lender Credit.” To keep things simple and straightforward, we charge you one lump sum rather than tacking on a bunch of miscellaneous fees.',
    tooltip4: 'The services and service providers in this section are required and must be chosen by the lender. You cannot shop separately for them. These legally-required services will vary depending on the type of loan you’ve chosen (e.g., VA, FHA, USDA).',
    tooltip5: 'These services are required, but you don’t have to purchase them through the lender. You can shop separately for them if you like. For example, you have the right to choose your own title company. However, our title vendors are typically priced better.',
    tooltip6: 'Government fees include recording fees, transfer taxes, and VA or FHA funding fees, if applicable.',
    tooltip7: 'This is a credit that will be subtracted from your total closing costs.',
    tooltip8: 'The amount of money needed to complete the transaction of buying a home. Cash to close is a combination of down payment, closing costs, and prepaids minus earnest money and credits. You’ll pay this amount at closing in the form of a cashier’s check or wire transfer.',
    tooltip9: 'Primary items include your down payment and the closing costs associated with the loan you\'ve selected.',
    tooltip10: 'Prepaids include mortgage interest and homeowners insurance premiums that are paid at the time of closing.',
    tooltip11: 'Escrows include property taxes and homeowners insurance. The amount due at closing depends on your closing date and what month the annual premiums are due. It\'s calculated to ensure you will have 14 months of escrow payments (1 year plus a 2 month cushion in case taxes or insurance are higher than the previous year) in your account by the time the premiums are due.',
    tooltip12: 'Credits are subtracted from your total cash to close. These include your earnest money payment and a seller and/or realtor credit (if applicable).',

  },
  RefinanceIrqSeeVaLoanOptionsPage: {
    title: 'Do you want to see VA Loan Options?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  RefinanceIrqDisabledVeteranPage: {
    title: 'Are you a disabled veteran?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  RefinanceIrqVaLoanBeforePage: {
    title: 'Have you had a VA loan before?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  BuildIrqSeeVaLoanOptionsPage: {
    title: 'Do you want to see VA Loan Options?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  BuildIrqDisabledVeteranPage: {
    title: 'Are you a disabled veteran?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  BuildIrqVaLoanBeforePage: {
    title: 'Have you had a VA loan before?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  PurchaseIrqSeeVaLoanOptionsPage: {
    title: 'Do you want to see VA Loan Options?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  PurchaseIrqDisabledVeteranPage: {
    title: 'Are you a disabled veteran?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  PurchaseIrqVaLoanBeforePage: {
    title: 'Have you had a VA loan before?',
    firstChoice: 'Yes',
    secondChoice: 'No',
    buttonTitle: 'Next',

  },
  BuildFirstTimePage: {
    title: 'Have you owned a home in the last 3 years?',
    firstChoice: 'Yes',
    secondChoice: 'No',

  },
  PurchaseIrqPropertyNotSupportedPage: {
    title: 'Sorry, this address is not currently supported.',
    subtitle: 'Ask your real estate agent for a list of reputable lenders in your area.',
    buttonTitle: 'Return to Home page',

  },
  BuildIrqPropertyNotSupportedPage: {
    title: 'Sorry, this address is not currently supported.',
    subtitle: 'Ask your real estate agent for a list of reputable lenders in your area.',
    buttonTitle: 'Return to Home page',

  },
  RefinanceIrqPropertyNotSupportedPage: {
    title: 'Sorry, this address is not currently supported.',
    subtitle: 'Ask your real estate agent for a list of reputable lenders in your area.',
    buttonTitle: 'Return to Home page',

  },

}